const withGroup = group => prevTemplate => ({
    ...prevTemplate,
    group,
});

export default withGroup;
